// Kevin Rademan (2018-09-07)
// TODO: This is violating the duck rules by accessing internals directly, BUT
// its also the root cause for many circular depernancies. Choosing the lesser evil
export { CONVERSATIONS_PAGE as REPORTS_MAIN_PAGE } from './conversations/pages'
